import {VolumeOff, VolumeUp} from '@material-ui/icons';
import React from 'react';

export const getButtonIcon = (enabled: boolean) => {
    if (enabled)
        return (<VolumeUp className="volume-icon" />);
    
    return (
        <VolumeOff
            className="volume-icon"
            color="disabled"
        />
    );
};
